import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-contact-name-block",
  type: "FormContactNameBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Name",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: true,
    },
  },
  meta: {
    canvasNameI18n: "builder_ui.block_type.form_contact_name",
  },
};
